export const optionsDonut = {
    chart: {
      type: "donut",
    },
    plotOptions: {
      pie: {
          donut: {
              size: '65px',
              labels: {
                  show: true,
                  total: {
                      show: true,
                      label: "insgesamt",
                      formatter: () => "0"
                  }      
              }
          }
      }
    },
    dataLabels: {
          enabled: true,
          formatter: function (val: any, opts: any) {
              return opts.w.config.series[opts.seriesIndex];
          }
    },
    responsive: [{
          breakpoint: 2480,
          options: {
              chart: {
                  width: '100%',
                  height: 350
              },
              legend: {
                  position: 'bottom'
              }
          }
    }],
    labels: [
      "Einzelcoaching",
      "Soziotherapie",
      "Betreutes Wohnen",
      "Gruppenmaßnahmen",
      "DRV Fallmanagement",
      "Private Weiterbildung"
    ],
    colors: [
        '#059448', // 1. Brand Green (Einzelcoaching)
        '#0f766e', // 2. Deep Petrol/Teal (Betreutes Wohnen)
        '#10b981', // 3. Emerald Green (Soziotherapie)
        '#0284c7', // 4. Soft Ocean Blue (DRV Fallmanagement)
        '#6b8e23', // 5. Olive/Sage Green (Private Weiterbildung - umjesto sive!)
        '#a7f3d0'  // 6. Soft Mint Green (Gruppenmaßnahmen)
    ]

  }

const donutColorsByCompany: Record<string, string[]> = {
    BSG: [
        '#059448', // 1. Brand Green
        '#0f766e', // 2. Deep Petrol/Teal
        '#10b981', // 3. Emerald Green
        '#0284c7', // 4. Soft Ocean Blue
        '#6b8e23', // 5. Olive/Sage Green
        '#a7f3d0'  // 6. Soft Mint Green
    ],
    BBQ: [
        '#1e40af', // 1. Brand Blue
        '#075985', // 2. Deep Ocean Blue
        '#0ea5e9', // 3. Sky Blue
        '#3b82f6', // 4. Bright Blue
        '#0369a1', // 5. Steel Blue
        '#93c5fd'  // 6. Soft Light Blue
    ]
};

export const getDonutColorsByCompany = (companyKey?: string) =>
    donutColorsByCompany[companyKey ?? ''] ?? donutColorsByCompany.BSG;